<script>
  import LoadingAnim from "./LoadingAnim.svelte";
</script>

<div class="bg">
  <LoadingAnim />
</div>

<style>
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    background: #0008;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }
</style>
